import { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { GeneralButton } from "../../../components";
import { EndPoints } from "../../../Constants/endpoints";
import { GetPatientInfo } from "../../../interface/GeneralResponse";
import { RootState } from "../../../redux/store";
import MedicalRecordHeader from "../MedicalRecordHeader/MedicalRecordHeader";
import PatientMedicalRecordBody from "../PatientMedicalRecords/MedicalRecordDetails/PatientMedicalRecordBody";
import { useGetData, usePostData } from "../../../hooks";
import { cleanEmptyValues } from "../utils";

const PreviewMedicalRecord = ({ updateOrCreateRecord, isLoading }: any) => {
  const { t } = useTranslation();
  const { PatientId, templateId } = useParams();

  const medicalRecord: any = useSelector(
    (state: RootState) => state.medicalRecord.record,
  );

  const GetMedicalRecord = usePostData(EndPoints.PreviewMedicalReport);
  const navigate = useNavigate();
  const location = useLocation();

  const handleBack = () => {
    navigate(location.state?.from || -1);
  };

  const { data } = useGetData<GetPatientInfo>(
    EndPoints.GetPatients,
    {
      refetchOnWindowFocus: true,
      enabled: !!PatientId,
    },
    PatientId,
  );
  const patientName = data?.Data?.FullName;

  useEffect(() => {
    if (medicalRecord) {
      const { Attributes, ...rest } = medicalRecord;
      const cleanedValues = cleanEmptyValues(rest);
      GetMedicalRecord.mutate({Attributes,...cleanedValues});
    }
    else {
      navigate(`/patient/${PatientId}/add-medical-record/${templateId}`);
    }
  }, []);

  return (
    <div className="relative h-[100dvh] bg-white p-8">
      <MedicalRecordHeader
        backRoute={
          PatientId
            ? `/patient/${PatientId}/add-medical-record/${templateId}`
            : undefined
        }
        selectedTemplateName={
          GetMedicalRecord?.data?.Data?.MedicalHistoryType?.Name
        }
      />
      <div className="mx-auto mt-8 max-w-[80%]">
        <p className="pb-2 font-semibold">
          {t("review_report_before_sending")}
        </p>
        <PatientMedicalRecordBody
          type="preview"
          GetMedicalRecord={GetMedicalRecord}
          className={"!max-h-[calc(100dvh-14rem)]"}
        />
      </div>
      <div className="absolute bottom-[4dvh] md:bottom-8 flex w-full justify-center gap-2">
        <GeneralButton
          className="!bg-orange"
          onClick={handleBack}
          title={t("edit_medical_report")}
        />
        <GeneralButton
          isLoading={isLoading}
          onClick={() => updateOrCreateRecord(medicalRecord)}
          title={t("send_to_patient", { patient: patientName })}
        />
      </div>
    </div>
  );
};

export default PreviewMedicalRecord;
